/* ------------------------------------------------------------------------------
@name: WEB_URL
@description: WEB_URL
--------------------------------------------------------------------------------- */

import { BASE_URL } from "./BASE_URL";

export const WEB_URL = {
	home: `${BASE_URL}`,
	login: `${BASE_URL}login`,
	accountLogin: `${BASE_URL}account/login`,
	dashboard: `${BASE_URL}dashboard`,
	registration: `${BASE_URL}registration`,
	medicine: `${BASE_URL}medicine`,
	pharmacy: `${BASE_URL}pharmacy`,
	satusehat: `${BASE_URL}satu-sehat/encounter`,
};

export const IMG_URL = `${BASE_URL}public/assets/img/dummy/`;
